import Button from '@mui/material/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

const SeeOriginalButton = ({
    route,
    isInExplore = false,
}: {
    route: string;
    isInExplore?: boolean;
}): JSX.Element => {
    const { t } = useTranslation();
    const title = t('indicators.seeOriginal');
    return (
        <Button
            component={Link}
            to={route}
            target="_blank"
            className={
                isInExplore
                    ? 'pendo-indicators-explore-see-original'
                    : 'pendo-indicators-library-see-original'
            }
            size="small"
            variant="outlined"
            sx={
                isInExplore
                    ? { flex: 0.5 }
                    : {
                          borderRadius: 1,
                          padding: (theme) => `0 ${theme.spacing(1)}`,
                          '&.MuiButtonBase-root': {
                              minHeight: '2rem',
                          },
                      }
            }
        >
            {title}
        </Button>
    );
};

export default SeeOriginalButton;
